// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';
import RelatedNotes from '../controls/relatedNotes';

myw.NotesPlugin = myw.Plugin.extend({
    /**
     * @class Provides additional Notes related functionality to the application<br/>
     * When myw.DetailsControls displays a feature, if it has notes, a new section is displayed which lists the associated notes.
     * @param  {Application} owner                       The application
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner) {
        myw.Plugin.prototype.initialize.call(this, owner);

        const ds = this.app.getDatasource('myworld');
        this.isNoteTableAccessible = !!ds.featuresDD['note'];
    },

    /****** FeatureDetailsControl API *****/
    updateFeatureDetailsDivFor(feature, parentDiv) {
        if (this.isNoteTableAccessible) {
            //Check if there are notes associated and if there are add a section that can be clicked to expand
            if (!this.relatedNotesControl) {
                parentDiv.append('<div id="related-notes-container"/>');
                this.relatedNotesControl = new RelatedNotes(this, {
                    divId: 'related-notes-container'
                });
            }
            this.relatedNotesControl.render(feature);
        }
    }
});

export default myw.NotesPlugin;
